module.exports = __webpack_public_path__ + "static/img/641.4dbd864.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/641.gif
// module id = A1Lr
// module chunks = 0